// External libraries
import gql from 'graphql-tag';

export const COMPLETE_3DS_CONFIRMATION_MUTATION = gql`
  mutation Complete3DSConfirmationMutation(
    $thirdPartyToken: String!
    $token: String!
  ) {
    completeThreeDSConfirmation(
      thirdPartyToken: $thirdPartyToken
      token: $token
    ) {
      flags {
        is3DSecureRequired
      }
    }
  }
`;
